import { createAction, props } from '@ngrx/store';
import { IUserAuthProfile } from '../../services';

const enum EAuthActions {
  initLoginCheck = '[Auth] Init Login Check',
  authenticated = '[Auth] Authenticated',
  notAuthenticated = '[Auth] Not Authenticated',
  login = '[Auth] login',
  loginNotification = '[Auth] Login Notification',
  logout = '[Auth] logout',
  logoutNotification = '[Auth] Logout Notification',
  sessionTerminated = '[Auth] Session Terminated',
  discoveryDocumentLoaded = '[Auth] Discovery Document Loaded',
  userProfileLoaded = '[Auth] User Profile Loaded',
}

const initLoginCheck = createAction(EAuthActions.initLoginCheck);
const authenticated = createAction(EAuthActions.authenticated);
const notAuthenticated = createAction(EAuthActions.notAuthenticated);
const login = createAction(EAuthActions.login);
const loginNotification = createAction(EAuthActions.loginNotification);
const logout = createAction(EAuthActions.logout);
const logoutNotification = createAction(EAuthActions.logoutNotification);
const sessionTerminated = createAction(EAuthActions.sessionTerminated);
const discoveryDocumentLoaded = createAction(EAuthActions.discoveryDocumentLoaded);
const userProfileLoaded = createAction(EAuthActions.userProfileLoaded, props<{ userProfile: IUserAuthProfile }>());

export const AUTH_ACTIONS = {
  initLoginCheck,
  authenticated,
  notAuthenticated,
  login,
  loginNotification,
  logout,
  logoutNotification,
  sessionTerminated,
  discoveryDocumentLoaded,
  userProfileLoaded,
};
